// This is the javascript entrypoint for the hero-video section.
// This file and all its inclusions will be processed through esbuild

class VideoSection extends HTMLElement {
  constructor() {
    super();

    theme.VideoSection = (function() {
      const selectors = {
        videoParent: '.video-parent-section'
      };

      function videoSection(container) {
        this.container = container.querySelector('[data-section-type="video-section"]');
        this.sectionId = this.container.getAttribute('data-section-id');
        this.namespace = '.video-' + this.sectionId;
        this.videoObject;

        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this),
          threshold: 500
        });
      }

      videoSection.prototype = Object.assign({}, videoSection.prototype, {
        init: function() {
          const dataDiv = this.container.querySelector('.video-div');
          if (!dataDiv) {
            return;
          }
          const type = dataDiv.dataset.type;
          const videoId = dataDiv.dataset.videoId;

          switch(type) {
            case 'youtube':
              this.initYoutubeVideo(videoId);
              break;
            case 'vimeo':
              this.initVimeoVideo(videoId);
              break;
            case 'mp4':
              this.initMp4Video();
              break;
          }
        },

        initYoutubeVideo: function(videoId) {
          this.videoObject = new theme.YouTube(
            'YouTubeVideo-' + this.sectionId,
            {
              videoId: videoId,
              videoParent: selectors.videoParent
            }
          );
        },

        initVimeoVideo: function(videoId) {
          this.videoObject = new theme.VimeoPlayer(
            'Vimeo-' + this.sectionId,
            videoId,
            {
              videoParent: selectors.videoParent
            }
          );
        },

        initMp4Video: function() {
          const mp4Video = 'Mp4Video-' + this.sectionId;
          const mp4Div = document.getElementById(mp4Video);
          const parent = mp4Div.closest(selectors.videoParent);

          if (mp4Div) {
            parent.classList.add('loaded');

            const playPromise = document.querySelector('#' + mp4Video).play();

            // Edge does not return a promise (video still plays)
            if (playPromise !== undefined) {
              playPromise.then(function() {
                  // playback normal
                }).catch(function() {
                  mp4Div.setAttribute('controls', '');
                  parent.classList.add('video-interactable');
                });
            }
          }
        },

        onUnload: function() {
          if (this.videoObject && typeof this.videoObject.destroy === 'function') {
            this.videoObject.destroy();
          }
        }
      });

      return videoSection;
    })();
  }

  connectedCallback() {
    this.videoSection = new theme.VideoSection(this);
  }

  disconnectedCallback() {
    this.videoSection.onUnload();
  }
}

customElements.define('video-section', VideoSection);
